import create from 'zustand'
import { CascaderOptionType } from 'antd/lib/cascader'
import { CultivatingTalentsStoreState } from './types'
import {
  GroupedCompanyWithLegalEntitiesAndCountries,
  Country,
  EmployeeWithRankAndTags,
  TalentsSeasonSettingsDto,
  EmployeeAndTag,
} from '../../types'

const initialValues = {
  storeInitialized: false,
  companiesAndCountries: [],
  companiesAndCountriesSelected: [],
  selected: { companyId: '', country: '' as Country },
  employees: [],
  employeesWithoutRank: [],
  rankedEmployees: [],
  activeSeasonKey: '',
  talentsSeasonSettings: undefined,
  rankingEditingInProgress: false,
  sortRanking: false,
}

export const useCultivatingTalentsStore = create<CultivatingTalentsStoreState>((set) => ({
  ...initialValues,

  initStore: (companiesAndCountries: GroupedCompanyWithLegalEntitiesAndCountries[]) =>
    set((state) => {
      const companiesAndCountriesSelected: CascaderOptionType[] = companiesAndCountries.map((company) => ({
        label: company.companyName,
        value: `${company.companyId}`,
        children: Array.from(new Set(company.companyCountries.map((countryAndLegalEntity) => countryAndLegalEntity.country))).map(
          (country) => ({
            label: country,
            value: `${country}`,
          }),
        ),
      }))

      const selected = {
        companyId: state.selected.companyId || companiesAndCountries[0].companyId,
        country: state.selected.country || (companiesAndCountries[0].companyCountries[0].country as Country),
      }

      return { companiesAndCountries, companiesAndCountriesSelected, selected, storeInitialized: true }
    }),

  resetStore: () => set({ ...initialValues }),

  setSelected: (companyId: string, country: Country) => set({ selected: { companyId, country } }),

  setEmployees: (employees: EmployeeWithRankAndTags[]) => set({ employees }),

  setEmployeesWithoutRank: (employeesWithoutRank: EmployeeAndTag[]) => set({ employeesWithoutRank }),

  setRankedEmployees: (rankedEmployees: EmployeeWithRankAndTags[]) => set({ rankedEmployees }),

  setTalentsSeasonSettings: (talentsSeasonSettings: TalentsSeasonSettingsDto | undefined) => set({ talentsSeasonSettings }),

  toggleRankingEditingInProgress: (value: boolean) => set({ rankingEditingInProgress: value }),

  setActiveSeasonKey: (activeSeasonKey: string) => set({ activeSeasonKey }),

  toggleSortRanking: (value: boolean) => set({ sortRanking: value }),
}))
